import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { RunExtractRefreshNow } from '../AppActionTypes';

export interface RunExtractRefreshNowAction extends Action {
    tasks: IContentInfo[];
}

export function runExtractRefreshNow(tasks: IContentInfo[]): RunExtractRefreshNowAction {
  return {
    type: RunExtractRefreshNow,
    tasks
  };
}
